import Uiconstants from "../../lib/UIconstants";
import DoubleChanceController from "../../controllers/double_chance/DoubleChanceController";
import { COMPONENTS } from "../../lib/constants";
import { isDesktop } from "react-device-detect";
// import { isDesktop } from "react-device-detect";

// let position = {
//   activeBot: {
//     x: isDesktop ? -27 : 0,
//     y: isDesktop ? 124 : 0,
//   },
//   passiveBot: {
//     x: isDesktop ? -26 : 0,
//     y: isDesktop ? 124 : 0,
//   },
//   activeTop: {
//     x: isDesktop ? -23 : 0,
//     y: isDesktop ? -24 : 0,
//   },
//   passiveTop: {
//     x: isDesktop ? -24 : 0,
//     y: isDesktop ? -24 : 0,
//   },
// };

// let scale = isDesktop ? 0.328 : 0;

export const DoubleChanceWidget = {
  name: COMPONENTS.DOUBLE_CHANCE_WIDGET,
  position: {
    x: 1410,
    y: 245,
  },
  controllers: [
    {
      Controller: DoubleChanceController,
      name: "DoubleChanceController",
      config: {
        item: Uiconstants.FTR_DOUBLE_CHANCE,
        holder: "holder",
      },
    },
  ],
  components: [
    {
      name: "holder",
      type: "Sprite",
      position: { x: 0, y: 0 },
      components: [
        {
          name: "double_wrapper",
          type: "SimpleButton",
          components: [
            {
              name: "bg",
              type: "MouseOverSprite",
              img: "double_chance_widget_bg",
              imgHover: "double_chance_widget_bg_hovered",
              components: [
                {
                  name: "double_chance_border",
                  type: "Sprite",
                  img: "double_chance_border",
                  position: { x: -25, y: -25 },
                },
                isDesktop && {
                  name: "fg",
                  type: "AnimatedSprite",
                  position: { x: 80, y: -103 },
                  animation: {
                    pattern: "wpassive$.png",
                    start: 0,
                    end: 43,
                    speed: 0.5,
                    precision: 2,
                    loop: true,
                    scale: {
                      x: 0.9,
                      y: 0.9,
                    },
                  },
                },
                {
                  name: Uiconstants.FTR_DOUBLE_CHANCE,
                  type: "SwitchButton",
                  position: { x: 28, y: 134 },
                  bgimg: "switcher_btn_on",
                  bg: "switcher_back_on",
                  fgimg: "switcher_btn_off",
                  fg: "switcher_back_off",
                  bgText: "DOUBLE_CHANCE_SWITCHER_ON",
                  fgText: "DOUBLE_CHANCE_SWITCHER_OFF",
                },
              ],
            },
            {
              name: "DOUBLE_CHANCE_VALUE",
              type: "Text",
              position: { x: 27, y: 23 },
              text: "DOUBLE_CHANCE_VALUE",
            },
            {
              name: "DOUBLE_CHANCE_CURRENCY",
              type: "Text",
              position: { x: 27, y: 42 },
              text: "DOUBLE_CHANCE_CURRENCY",
            },
            {
              name: "DOUBLE_CHANCE_TITLE",
              type: "Text",
              position: { x: 27, y: 73 },
              text: "DOUBLE_CHANCE_TITLE",
            },
            {
              name: "DOUBLE_CHANCE_SUBTITLE",
              type: "Text",
              position: { x: 93, y: 85.5 },
              text: "DOUBLE_CHANCE_SUBTITLE",
            },
          ],
        },
      ],
    },
  ],
};
